export default "__VITE_ASSET__a1d208dd__"